import { ApolloError } from "@apollo/client";

export interface QueryData<TData> {
  loading: boolean;
  error: ApolloError | undefined | Error | null;
  data: TData | undefined;
}

export interface QueryDates {
  startDate: string;
  endDate: string;
}

export enum PERIOD_RANGE {
  FROM_START = "CALENDYEAR-0",
  THIS_MONTH = "CALMONTH-0",
  LAST_MONTH = "CALMONTH-1",
  THIS_QUARTER = "CALQUARTER-0",
  LAST_QUARTER = "CALQUARTER-1",
  THIS_HALF = "CALHALFYEAR-0",
  LAST_HALF = "CALHALFYEAR-1",
  THIS_YEAR = "CALYEAR-0",
  LAST_YEAR = "CALYEAR-1",
  LAST_1_YEARS = "YEARS-1",
  LAST_3_YEARS = "YEARS-3",
  LAST_5_YEARS = "YEARS-5",
  LAST_7_DAYS = "DAYS-6",
  GIVEN = "GIVEN",
}

export enum PORTFOLIO_STATUS {
  ACTIVE = "A",
  CLOSED = "C",
  PASSIVE = "P",
}

type Values<T> = T[keyof T];
export type PortfolioStatus = Values<typeof PORTFOLIO_STATUS>;

export interface Herring {
  smoked: boolean;
  isBockling: boolean;
}
